<template>
  <div>
    <a-page-header>
      <template v-slot:title>
        <a-space align="center">
          <div
            class="ant-descriptions-title"
            style="font-size: 20px; margin-bottom: 0px"
          >
            进场公开招租申请
          </div>
        </a-space>
      </template>
      <!-- actions -->
      <template v-slot:extra>
        <!-- 固钉 -->
        <a-affix :offset-top="10" class="page-header-affix">
          <a-button-group style="margin-right: 2px">
            <!-- 编辑 -->
            <template v-if="isEditStatus">
              <a-button @click="back">返回</a-button>
              <a-button @click="onSave">保存</a-button>
              <a-button type="primary" @click="onSubmit">提交</a-button>
            </template>
            <!-- 审批中/其他 -->
            <a-button v-else @click="back" type="primary">返回</a-button>
          </a-button-group>
        </a-affix>
      </template>

      <ApplyInfo
        :isEditable="toDetailData.isEditable"
        :webId="toDetailData.webId"
        :selectHouseList="toDetailData.selectHouseList"
        ref="applyInfoRef"
        @back="back()"
      ></ApplyInfo>

      <!-- 回到最高点 -->
      <a-back-top style="margin-right: -100px" />
    </a-page-header>
  </div>
</template>

<script>
const EDIT_STATUS = ["编辑中", "-1", "0", "11", "13", "14", "19", "30"];
import ApplyInfo from "./applyInfo/ApplyInfo";
import { scrollToTop } from "@/utils/util";
export default {
  props: {
    toDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ApplyInfo,
  },
  data() {
    return {};
  },
  computed: {
    isEditStatus() {
      return EDIT_STATUS.includes(this.toDetailData.projectStatus);
    },
  },
  methods: {
    back() {
      this.$emit("changeToLeader");
      scrollToTop(this);
    },
    onSave() {
      // 保存（不提交）
      this.$refs.applyInfoRef.handleSave();
    },
    onSubmit() {
      // 提交（校验 + 提交）
      this.$refs.applyInfoRef.handleSubmit();
    },
  },
};
</script>

<style lang="less" scoped>
.page-header-affix {
  z-index: 1000;
}

.page-header-affix /deep/ .ant-affix {
  z-index: 1000 !important;
}
</style>